import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { MODULE_KEYS, MODULE_CONFIG, modulePath } from "../data/modules";

// Built from the shared module catalog so the nav dropdown stays in sync with
// the module showcase pages (and the footer's SOLUTIONS list).
const MODULE_LINKS = MODULE_KEYS.map((key) => ({
  key,
  label: key === "profile" ? "ASAP Profil" : MODULE_CONFIG[key].label,
  to: modulePath(key),
}));

const MarketingHeader = () => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [modulesOpen, setModulesOpen] = useState(false);

  const closeAll = () => {
    setOpen(false);
    setModulesOpen(false);
  };

  const handleNavClick = (e, href) => {
    e.preventDefault();
    if (window.location.pathname === "/") {
      const id = href.split("#")[1];
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: "smooth" });
    } else {
      navigate(href);
    }
    closeAll();
  };

  return (
    <nav className="mk-nav" aria-label="Navigation principale">
      <Link to="/" className="mk-brand" aria-label="ASAP Hub - Accueil">
        <span className="mk-brand-mark" aria-hidden="true" />
        <span>ASAP Hub</span>
      </Link>

      <div className="mk-nav-links" id="mkNavLinks" style={open ? { display: "flex" } : undefined}>
        <a href="/#plateforme" onClick={(e) => handleNavClick(e, "/#plateforme")}>Plateforme</a>

        <div
          className={`mk-nav-dropdown${modulesOpen ? " open" : ""}`}
          onMouseEnter={() => setModulesOpen(true)}
          onMouseLeave={() => setModulesOpen(false)}
        >
          <a
            href="/#modules"
            aria-haspopup="true"
            aria-expanded={modulesOpen}
            onClick={(e) => {
              e.preventDefault();
              setModulesOpen((v) => !v);
            }}
          >
            Modules <span className="mk-nav-caret" aria-hidden="true">▾</span>
          </a>
          <div className="mk-nav-menu" role="menu">
            {MODULE_LINKS.map((m) => (
              <Link key={m.key} to={m.to} role="menuitem" onClick={closeAll}>
                {m.label}
              </Link>
            ))}
          </div>
        </div>

        <a href="/#tarifs" onClick={(e) => handleNavClick(e, "/#tarifs")}>Tarifs</a>
        <a href="/#faq" onClick={(e) => handleNavClick(e, "/#faq")}>FAQ</a>
      </div>

      <div className="mk-nav-actions">
        <Link to="/login" className="mk-btn mk-btn-ghost">Se connecter</Link>
        <Link to="/contact" className="mk-btn mk-btn-primary" data-testid="header-cta-demo">Demander une démo</Link>
        <button
          className="mk-menu-btn"
          aria-label="Ouvrir le menu"
          onClick={() => setOpen((v) => !v)}
        >
          ☰
        </button>
      </div>
    </nav>
  );
};

export default MarketingHeader;
